module.exports = __webpack_public_path__ + "img/maya.b0208fff.png";